import { PrintAndSendWizardReduxState, PrintAndSendWizardActionTypes, UPDATE_PRINT_AND_SEND_WIZARD_STATE, SET_STEP_INDEX, NEXT_STEP_INDEX, PREVIOUS_STEP_INDEX, RESET_PRINT_AND_SEND_FIELDS, SET_ACTIVE_ACCORDION_INDEX } from './types'

const initialState: PrintAndSendWizardReduxState = {
    stepIndex: 0,
    activeAccordionIndex: 0
}

export function printAndSendWizardReducer(state = initialState, action: PrintAndSendWizardActionTypes): PrintAndSendWizardReduxState {
    switch (action.type) {
        case RESET_PRINT_AND_SEND_FIELDS: {
            return {
                ...initialState,
                codiciLavorazione: state.codiciLavorazione ? [...state.codiciLavorazione] : undefined
            }
        }
        case UPDATE_PRINT_AND_SEND_WIZARD_STATE: {
            return {
                ...state,
                ...action.payload
            }
        }
        case SET_STEP_INDEX: {
            return {
                ...state,
                stepIndex: action.stepIndex
            }
        }
        case NEXT_STEP_INDEX: {
            return {
                ...state,
                stepIndex: state.stepIndex !== undefined ? state.stepIndex + 1 : 0
            }
        }
        case PREVIOUS_STEP_INDEX: {
            return {
                ...state,
                stepIndex: state.stepIndex !== undefined ? state.stepIndex - 1 : 0
            }
        }
        case SET_ACTIVE_ACCORDION_INDEX: {
            return {
                ...state,
                activeAccordionIndex: action.activeAccordionIndex
            }
        }

        default:
            return state
    }
}